const startsWithVowelPattern = /^[aeiou]/i

export function determineIndefiniteArticle(word: string): string {
  if (startsWithVowelPattern.test(word)) {
    return 'an'
  }

  return 'a'
}
